module.exports = __webpack_public_path__ + "img/splash_demo-600x450.c4433e16.jpg";